import ga4 from "@/lib/tracking/ga4Core";

export const trackRegisterInterest = ({
  id,
  source,
  journey,
  listingType,
  category,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "registration_interest",
    source,
    journey_details: journey,
    listing_type: listingType,
    property_category: category,
    listing_id: id,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackCallDeveloper = ({ source }) => {
  const eventName = "contact_user_developer_call";
  const eventParams = {
    method: "call_init",
    journey_details: "projects_listing",
    source,
    target: "contact_button",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackContactUserProject = ({ source }) => {
  const eventName = "contact_user_project_wa";
  const eventParams = {
    method: "whatsapp_init",
    journey_details: "projects_listing",
    source,
    target: "contact_button",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackGetProjectLocation = ({
  source,
  listingType,
  propertyCategory,
  page,
}) => {
  const eventName = "view_location";
  const eventParams = {
    method: "get_directions",
    journey_details: "projects_listing",
    source,
    target: `go_to_the_site_${page}`,
    listing_type: listingType,
    property_category: propertyCategory,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackPlayProjectVideo = () => {
  const eventName = "video_start";
  const eventParams = {
    method: "play_video",
    journey_details: "projects_listing",
  };

  ga4.trackUserInteraction(eventName, eventParams);
}
